/**
 * Cadastre / parcel intelligence availability by country.
 * Live automated parcels remain Swiss-only (geo.admin / RDPPF).
 * Other countries may have official portals without a public API we can hook.
 */

export const ELANDJAMAICA_URL = 'https://elandjamaica.nla.gov.jm/';

/**
 * @param {string} countryCode
 * @returns {{
 *   enabled: boolean,
 *   title: string,
 *   body: string,
 *   linkUrl?: string,
 *   linkLabel?: string,
 * }}
 */
export function resolveCadastreAvailability(countryCode) {
  const cc = String(countryCode || 'CH').trim().toUpperCase();
  if (cc === 'CH') {
    return {
      enabled: true,
      title: 'Swiss cadastre',
      body: 'Live parcel intelligence via Swiss federal / cantonal layers.',
    };
  }
  if (cc === 'JM') {
    return {
      enabled: false,
      title: 'Cadastre unavailable (no public API)',
      body:
        'Jamaica’s National Land Agency runs eLandjamaica (free map browse; titles and '
        + 'valuation images are paid). There is no public live parcel GIS API comparable '
        + 'to Swiss geo.admin, so we cannot auto-fill surface / zones. Address search and '
        + 'AI market price still work — enter land size manually.',
      linkUrl: ELANDJAMAICA_URL,
      linkLabel: 'Open eLandjamaica',
    };
  }
  return {
    enabled: false,
    title: 'Cadastre unavailable',
    body:
      `Live cadastre is Swiss-only today. Address search and AI market price still work for ${cc}. `
      + 'Enter land size manually until a local parcel provider is connected.',
  };
}
